export class ShopReportFileCreateModel {
  public ShopReportId?: number;
  public Path?: string;
  public Document?: string;
  public DocumentNo?: number;
  public Item?: number;
  public IsDeleted?: boolean;
}
export default ShopReportFileCreateModel;
